import { Component } from 'react';
import { withRouter } from 'react-router-dom';

const HEARTBEAT_INTERVAL_MS = 15000;

function createId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

class VisitTrackerBase extends Component {
  componentDidMount() {
    this.sessionId = sessionStorage.getItem('visitSessionId') || createId();
    sessionStorage.setItem('visitSessionId', this.sessionId);
    this.startVisit(this.props.location.pathname);

    this.heartbeatTimer = window.setInterval(
      () => this.updateVisit('heartbeat'),
      HEARTBEAT_INTERVAL_MS
    );
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.updateVisit('end');
      this.startVisit(this.props.location.pathname);
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.heartbeatTimer);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.updateVisit('end');
  }

  handleBeforeUnload = () => {
    this.updateVisit('end', true);
  };

  handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      this.updateVisit('heartbeat', true);
    }
  };

  startVisit(path) {
    this.currentVisit = {
      visitId: createId(),
      sessionId: this.sessionId,
      path,
      startedAtUtc: new Date().toISOString()
    };
    this.post('/api/visits/start', this.currentVisit);
  }

  updateVisit(action, keepalive = false) {
    if (!this.currentVisit) {
      return;
    }

    this.post(`/api/visits/${action}`, this.currentVisit, keepalive);
  }

  post(url, body, keepalive = false) {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive
    }).catch(() => {
      // Analytics must never interrupt the visitor's experience.
    });
  }

  render() {
    return null;
  }
}

export const VisitTracker = withRouter(VisitTrackerBase);
